import { Box, Button, Text, useResponsive } from '@bitrise/bitkit';

import InternalFooter from '@/components/InternalFooter/InternalFooter';
import Page, { PageProps } from '@/components/page/Page';
import ContentWrapper from '@/components/page/ContentWrapper';
import BitbotLogoWithText from '@/components/page/PageHeader/PageHeaderContent/BitbotLogoWithText';

import { logInPath, signUpPath } from '@/utils/monolithApiRouteService';

const PublicBuildHeader = () => {
  return (
    <Box as="header" className="page-header" position="sticky" top="0" left="0" right="0" zIndex="300">
      <Box paddingY="16" background="linear-gradient(88.41deg, #760FC3 0%, #0DD3C5 100%)">
        <ContentWrapper display="flex" alignItems="center" justifyContent="space-between">
          <BitbotLogoWithText />
          <Box display="flex" gap="16">
            <Button
              as="a"
              href={`${logInPath()}?sign_in_redirect=${window.location.pathname}`}
              variant="tertiary"
              target="_blank"
              color="neutral.100"
              _active={{
                background: 'rgba(255, 255, 255, .4)',
              }}
              _focusVisible={{
                background: 'rgba(255, 255, 255, .3)',
              }}
              _hover={{
                background: 'rgba(255, 255, 255, .2)',
              }}
            >
              Log in
            </Button>
            <Button variant="secondary" as="a" href={signUpPath()} target="_blank">
              Sign up
            </Button>
          </Box>
        </ContentWrapper>
      </Box>
    </Box>
  );
};

const PublicBuildBanner = () => {
  const { isMobile } = useResponsive();
  return (
    <Box
      color="neutral.100"
      paddingTop="8"
      paddingBottom="24"
      background="linear-gradient(88.41deg, #760FC3 0%, #0DD3C5 100%)"
    >
      <ContentWrapper display="flex" flexDirection="column" gap="8">
        <Text size="5">
          <strong>Automate everything</strong> as a service
        </Text>
        <Text>
          Mobile Continuous Integration and Delivery for your whole team, with dozens of integrations
          {!isMobile ? <br /> : ' '}
          for your favourite services.
        </Text>
      </ContentWrapper>
    </Box>
  );
};

export type PublicBuildPageProps = PageProps & { footerBackground?: string };

const PublicBuildPage = ({
  children,
  footerBackground,
  withoutFooter,
  ...rest
}: PublicBuildPageProps & { withoutFooter?: boolean }): JSX.Element => {
  return (
    <Page {...rest}>
      <PublicBuildHeader />
      <PublicBuildBanner />
      <Box as="main" display="flex" flexDirection="column" flexGrow={1}>
        {children}
      </Box>
      {!withoutFooter && <InternalFooter />}
    </Page>
  );
};

export default PublicBuildPage;
